import React, { Component } from "react";
import Navigation from "./Components/Navigation";
import Footer from "./Components/Footer";
import Appmain from "./Components/Appmain";
import "./index.css";

class App extends Component {
  render() {
    return (
	<div>
	<Navigation/>
	<div className="content">
	<Appmain/>
	</div>
	<Footer/>
	</div>
    );
  }
}

export default App;
